import { Box, Typography } from "@mui/material";
import { getGridTemplateColumns, gridRowSx } from "./confirmDraftEventsUtils";

export const GridHeader = ({
	showCheckbox = false,
	showAction = false,
	showChangedFields = false,
}: {
	showCheckbox?: boolean;
	showAction?: boolean;
	showChangedFields?: boolean;
}) => (
	<Box
		sx={{
			...gridRowSx,
			gridTemplateColumns: getGridTemplateColumns({
				showAction,
				showChangedFields,
			}),
			backgroundColor: "grey.100",
			borderBottom: "2px solid",
			borderColor: "divider",
			justifyContent: "flex-start",
		}}
	>
		{showCheckbox ? <Box /> : null}
		{showAction ? (
			<Box>
				<Typography variant="caption" fontWeight={600}>
					Action
				</Typography>
			</Box>
		) : null}
		<Box>
			<Typography variant="caption" fontWeight={600}>
				Section
			</Typography>
		</Box>
		<Box>
			<Typography variant="caption" fontWeight={600}>
				Details (t)
			</Typography>
		</Box>
		<Box>
			<Typography variant="caption" fontWeight={600}>
				Start
			</Typography>
		</Box>
		<Box>
			<Typography variant="caption" fontWeight={600}>
				End
			</Typography>
		</Box>
		<Box>
			<Typography variant="caption" fontWeight={600}>
				Duration
			</Typography>
		</Box>
		{showChangedFields ? (
			<Box>
				<Typography variant="caption" fontWeight={600}>
					Changed Fields
				</Typography>
			</Box>
		) : null}
	</Box>
);
